/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingAllocationDataDto } from './buildingAllocationDataDto';
import { BuildingSectionApplicationItemDto } from './buildingSectionApplicationItemDto';
import { GroupedBuildingSectionDto } from './groupedBuildingSectionDto';
import { BuildingAccessData } from './buildingAccessData';
import { BuildingAmenityData } from './buildingAmenityData';
import { BuildingBaseData } from './buildingBaseData';


export interface BuildingApplicationDetailDto { 
    id: string;
    baseData: BuildingBaseData;
    allocationData: BuildingAllocationDataDto;
    accessData: BuildingAccessData;
    amenityData: BuildingAmenityData;
    applicationCreator: string;
    status: BuildingApplicationDetailDto.StatusEnum;
    rejectComment?: string;
    buildingSectionApplications: Array<BuildingSectionApplicationItemDto>;
    groupedBuildingSections?: Array<GroupedBuildingSectionDto>;
}
export namespace BuildingApplicationDetailDto {
    export type StatusEnum = 'PENDING' | 'ACCEPTED' | 'REJECTED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Accepted: 'ACCEPTED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum
    };
}


